'use strict';

import React from 'react';

import FaBars from 'react-icons/lib/fa/bars'
import FaClose from 'react-icons/lib/fa/close'
import ContactForm from './ContactForm.js'

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.state = {
      menuVisible: false
    }
  }

  toggleMenu() {
    this.setState({
      menuVisible: !this.state.menuVisible
    });
  }

  closeMenu() {
    this.setState({
      menuVisible: false
    });
  }

  render() {
    return (
      <nav className={this.state.menuVisible ? 'menu-component visible' : 'menu-component' }>
        <button className="menu-toggle-button" onClick={this.toggleMenu}>
          {this.state.menuVisible && <FaClose />}
          {!this.state.menuVisible && <FaBars />}
          <span className="text">Menu</span>
        </button>
        <div id="navigation-links" className={this.state.menuVisible ? 'navigation-links visible' : 'navigation-links' }>
          <a onClick={this.closeMenu} href='#inicio'>Início</a>
          <a onClick={this.closeMenu} href='#servicos'>Serviços</a>
          <a onClick={this.closeMenu} href='#empresa'>Empresa</a>
          <a onClick={this.closeMenu} href='#clientes'>Clientes</a>
          <a onClick={this.closeMenu} href='#contactos'>Contactos</a>
        </div>
        {/* <ContactForm /> */}
      </nav>
    );
  }
}

Menu.displayName = 'Menu';

// Uncomment properties you need
// Menu.propTypes = {};
// Menu.defaultProps = {};

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js